<main class="main">
  <section class="main__portal portal">
    <aside class="portal__aside">
      <sa-aside [links]="links"></sa-aside>
    </aside>
    <section class="portal__page">
      <div class="portal__page-content">
        <h1 class="portal__page-title">{{ title }}</h1>
        <div>
          <router-outlet></router-outlet>
        </div>
      </div>
    </section>
  </section>
</main>
